export const TOGGLE_CONFIRM_JOB_TEMPLATE_DELETE =
  'TOGGLE_CONFIRM_JOB_TEMPLATE_DELETE';
export const SORT_JOB_TEMPLATES = 'SORT_JOB_TEMPLATES';
export const FILTER_JOB_TEMPLATES = 'FILTER_JOB_TEMPLATES';
